/* stylelint-disable string-quotes */
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
    colorVariables,
    gutterSizes,
    fontWeights,
    mediaQuery,
    breakpoints,
    fontSizes,
} from "@gumtree/ui-library/src/base/theme";
import { newLayout } from "../../app.style";

export const AttributesRow = styled.dl<{ isMobileCardsLayout: boolean }>`
    display: flex;
    border-bottom: 1px solid ${colorVariables.borderLighter};
    padding: ${gutterSizes.small} 0;
    margin: ${gutterSizes.xsmall} 0;
    margin: ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout && gutterSizes.small}; /* stylelint-disable-line */

    ${mediaQuery.until(breakpoints.medium)} {
        :last-of-type {
            border-bottom: none;
            padding-bottom: 0;
        }
    }

    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout &&
        css`
            ${mediaQuery.from(breakpoints.medium)} {
                padding-left: ${gutterSizes.base};
                padding-right: ${gutterSizes.base};
            }
        `}
`;

export const Container = styled.div<{
    isMobileCardsLayout: boolean;
    isMotors: boolean;
    isSingleAttr: boolean;
}>`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${({ isMobileCardsLayout }) => isMobileCardsLayout && newLayout}

    ${({ isSingleAttr }) =>
        isSingleAttr
            ? css`
                  padding: ${gutterSizes.medium} 0;

                  ${mediaQuery.until(breakpoints.small)} {
                      padding: ${gutterSizes.medium} ${gutterSizes.base};
                  }
              `
            : css`
                  ${AttributesRow} {
                      padding: ${gutterSizes.medium} 0;
                      margin-bottom: ${gutterSizes.medium};
                  }
              `}

    ${({ isMotors }) =>
        isMotors &&
        css`
            ${mediaQuery.from(breakpoints.medium)} {
                margin-top: ${gutterSizes.large};
                margin-bottom: ${gutterSizes.large};
            }

            ${mediaQuery.from(breakpoints.large)} {
                margin-bottom: ${gutterSizes.xlarge};
            }
        `}

    ${mediaQuery.from(breakpoints.medium)} {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(195px, 1fr));
        grid-column-gap: ${gutterSizes.large};
    }
`;

export const HiddenSeoTitle = styled.h2`
    display: none;
`;

export const AttributesColumn = styled.dt`
    width: 50%;
    margin: 0;
    color: ${colorVariables.textNeutral};
`;

export const AttributesValue = styled(AttributesColumn)<{ isMobileCardsLayout: boolean }>`
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.base};
    line-height: 22px;
    text-align: right;
    color: ${colorVariables.textPrimary};
`.withComponent("dd");
